// permissionUtils.ts
export interface Permission {
    id: string;
    name: string;       // e.g., "create", "edit", "view"
    value: string;      // e.g., "true", "false", "none"
    model: string;      // e.g., "courses", "students", etc.
    parentPermission?: Permission | null;
  }
  
  export interface GroupedPermissions {
    subLevelPermissions: { [key: string]: Permission[] };
    activeParentPermissions: string[];
  }
  
  /**
   * Groups an array of permissions by their parent name (or the permission's own name if no parent exists).
   * Only permissions with a truthy and not "none"/"false" value are included.
   */
  export function groupUserPermissions(
    permissions: Permission[]
  ): GroupedPermissions {
    const grouped = permissions.reduce((acc: { [key: string]: Permission[] }, permission) => {
      const key = permission?.parentPermission
        ? permission.parentPermission?.name?.toLowerCase()
        : permission?.name?.toLowerCase();
  
      const normalizedValue = permission.value ? permission.value.toLowerCase() : "";
      if (normalizedValue && normalizedValue !== "none" && normalizedValue !== "false") {
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(permission);
      }
      return acc;
    }, {});
  
    const activeParentPermissions = Object.keys(grouped);
    return {
      subLevelPermissions: grouped,
      activeParentPermissions,
    };
  }
  